import ModalContainer from "../../common/ModalContainer";
import { ReviewBusinessProfile } from "../../ProfileSurvey/New/ProfileSurvey";

const CustomerDetailBusinessDetailModal = ({
  open,
  setOpen,
  data,
  reload,
  setLoading,
  loading,
  callback,
}) => {
  return (
    <>
      <ModalContainer open={open} setOpen={setOpen} title="Business Detail">
        <ReviewBusinessProfile
          user={data}
          callback={(res, response) => {
            if (res) {
              setOpen(false);
              callback(response?.data?.data);
            }
          }}
        />
      </ModalContainer>
    </>
  );
};

export default CustomerDetailBusinessDetailModal;
